import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PayWithAirwallex.CompleteAirwallexPaymentPopup', {
    successPay: 'All payments are successfully sent to the Airwallex processing',
});
